import { API } from '../../../common/api/constants';

// ПОЛУЧИТЬ ВСЕ ШАБЛОНЫ ПРЕДЛОЖЕНИЯ
export const GET_ALL_TEMPLATES = `${API}/offer/templates/profile/{profile_id}`;

// ПОЛУЧИТЬ ВСЕ ШАБЛОНЫ ПРЕДЛОЖЕНИЯ
export const GET_TEMPLATE_BY_ID = `${API}/offer/template/{offer_template_id}/profile/{profile_id}`;

// ОБНОВИТЬ ШАБЛОН ПРЕДЛОЖЕНИЯ ПО ПРОФИЛЮ ПЕРЕВОЗЧИКА
export const UPDATE_TEMPLATE = `${API}/offer/template/by_profile`;

// СОЗДАТЬ ШАБЛОН ПРЕДЛОЖЕНИЯ ПО ПРОФИЛЮ ПЕРЕВОЗЧИКА
export const CREATE_TEMPLATE = `${API}/offer/template/profile`;

// УДАЛИТЬ ШАБЛОН ПРЕДЛОЖЕНИЯ ПО ПРОФИЛЮ ПЕРЕВОЗЧИКА
export const DELETE_TEMPLATE = `${API}/offer/template/{offer_template_id}/profile/{profile_id}`;
